import { render, staticRenderFns } from "./Customizacao.vue?vue&type=template&id=e62a6dac&scoped=true&"
import script from "./Customizacao.vue?vue&type=script&lang=js&"
export * from "./Customizacao.vue?vue&type=script&lang=js&"
import style0 from "./Customizacao.vue?vue&type=style&index=0&id=e62a6dac&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../../frontend/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e62a6dac",
  null
  
)

export default component.exports